import { createFileRoute } from '@tanstack/react-router';
import { AlarmsPage } from '@/features/alarms';
// the schema module only: the route config is in the main bundle, the page stays in the lazy chunk
import { alarmsSearchSchema } from '@/features/alarms/search';

/** "Mezon monitoringi" — alarm events and sound settings (03-modules §8; legacy 14:20932, 14:20028). */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/alarms')({
  validateSearch: alarmsSearchSchema,
  component: AlarmsRoute,
});

function AlarmsRoute() {
  const { tenant } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AlarmsPage
      tenant={tenant}
      search={search}
      onSearch={(patch, opts) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: opts?.replace })}
    />
  );
}
